import { UserVoteCount } from '~/definitions/report';

export const DEFAULT_USER_VOTE_COUNT: UserVoteCount = {
    stand: 0,
    web: 0,
};

export const VOTE_REPORT_EMAIL = {
    company: {
        subject: 'Valgresultater',
        message: 'Valgresultater vedlagt i kommaseparert fil',
    },
    region: {
        subject: 'Valgresultater',
        message: 'Valgresultater vedlagt i kommaseparert fil',
    },
    stand: {
        subject: 'Valgresultater',
        message: 'Valgresultater vedlagt i kommaseparert fil',
    },
};

export const VOTE_REPORT_TABLE_HEADING = {
    name: 'Navn',
    votesFrom: 'Stemmer fra',
    web: 'WEB',
    stand: 'STAND',
    total: 'Totalt',
};

export const STAND_REPORT_TABLE_HEADING = {
    user_id: 'Medlem',
    ts: 'Tidspunkt',
};
